import TableActionMenu from "../../../../../../components/table-action-menu/table-action-menu";
import { Link } from "react-router-dom";
import { formatNumber } from "../../../../../../utils/utils";
import {
  exportEstimate,
  exportTimeline,
  exportGantt,
} from "../utils/pdfExportUtils";

export const tableMenuOptions = (projectData, companyDetails) => {
  const options = [
    {
      title: "View Estimate PDF",
      value: "view-estimate",
      onClick: async () => {
        const { timelines, id } = projectData;

        const milestones = timelines?.milestones || [];
        const materials = Array.isArray(timelines?.materials)
          ? timelines.materials
          : [];

        await exportEstimate({
          projectData: {
            ...projectData,
            timelines: { milestones, materials },
          },
          companyDetails,
          getNextEstimatePdfId: async () => id, // Simulate PDF ID generation
        });
      },
    },
    {
      title: "View Timeline PDF",
      value: "view-timeline",
      onClick: () => {
        exportTimeline({ projectData, companyDetails });
      },
    },
    {
      title: "View Gantt Chart",
      value: "view-gant",
      onClick: () => {},
    },
  ];
  return options;
};

export const groupPlanColumns = (companyDetails) => {
  return [
    {
      name: "ID",
      dataKey: "id",
      width: "100px",
      align: "left",
    },
    {
      name: "Plan Name",
      dataKey: "projectName",
      width: "400px",
      align: "left",
      render: (cellData, rowData) => {
        const projectUrl = `/projectsview/${rowData.id}/details?isGroupView=false`;
        return (
          <Link
            to={projectUrl}
            style={{
              textDecoration: "underline",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            {cellData}
          </Link>
        );
      },
    },

    {
      name: "Status",
      dataKey: "status",
      width: "150px",
      align: "left",
    },

    {
      name: "Created (mm/dd/yyyy)",
      dataKey: "dateCreated",
      width: "150px",
      align: "left",
    },

    {
      name: "Services",
      dataKey: "plannerServiceValue",
      width: "150px",
      align: "left",
      render: (cellData, rowData) => {
        return `$ ${formatNumber(cellData)}`;
      },
    },

    {
      name: "Materials",
      dataKey: "materials",
      width: "150px",
      align: "left",
      render: (cellData, rowData) => {
        return `$ ${cellData}`;
      },
    },

    {
      name: "Total",
      dataKey: "projectTotal",
      width: "150px",
      align: "left",
      render: (cellData, rowData) => {
        return `$ ${formatNumber(cellData)}`;
      },
    },
    {
      name: "Invoiced Service Value",
      dataKey: "invoiceValue",
      width: "150px",
      align: "left",
      render: (cellData, rowData) => {
        return `$ ${formatNumber(cellData) || "0.00"}`;
      },
    },
    {
      name: "",
      dataKey: "",
      width: "10px",
      maxWidth: "10px",
      align: "left",
      render: (cellData, rowData) => {
        return (
          <div>
            <TableActionMenu
              noBorder
              options={tableMenuOptions(rowData, companyDetails)}
            />
          </div>
        );
      },
    },
  ];
};
